import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	icons: {
		display: "flex",
		flexWrap: "wrap",
		gap: theme.spacing(2),
		padding: theme.spacing(0, 3),
		[theme.breakpoints.up("md")]: {
			gap: theme.spacing(4)
		},
		[theme.breakpoints.up("lg")]: {
			padding: theme.spacing(0, 8)
		}
	},
	item: {
		alignItems: "center",
		display: "flex",
		justifyContent: "center",
		[theme.breakpoints.up("sm")]: {
			"& svg": {
				width: "64px !important"
			}
		},
		[theme.breakpoints.up("md")]: {
			"& svg": {
				width: "115px !important"
			}
		}
	}
}));

export default styles;
